class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");

    this.input.addEventListener("input", this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(
      `/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=variants.sku,tag,vendor,title,product_type,variants.title`
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })

      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        if (
          !!this.predictiveSearchResults.querySelector(
            ".search-results-product-count"
          )
        ) {
          let searchResultsProduct = this.predictiveSearchResults
            .querySelector(".search-results-product-count")
            .getAttribute("data-results");
          if (Number(searchResultsProduct) < 1) {
            if (
              !!this.predictiveSearchResults.querySelector(
                ".predictive-search__tab-title-product"
              )
            ) {
              let searchResultsProductTitle =
                this.predictiveSearchResults.querySelector(
                  ".predictive-search__tab-title-product"
                );
              searchResultsProductTitle.classList.add("hidden");
            }
          }
        }
        if (
          !!this.predictiveSearchResults.querySelector(
            ".search-results-collection-count"
          )
        ) {
          let searchResultsCollection = this.predictiveSearchResults
            .querySelector(".search-results-collection-count")
            .getAttribute("data-results");
          if (Number(searchResultsCollection) < 1) {
            if (
              !!this.predictiveSearchResults.querySelector(
                ".predictive-search__tab-title-collection"
              )
            ) {
              let searchResultsCollectionTitle =
                this.predictiveSearchResults.querySelector(
                  ".predictive-search__tab-title-collection"
                );
              searchResultsCollectionTitle.classList.add("hidden");
            }
          }
        }
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.setAttribute("aria-hidden", "false");
  }

  close() {
    this.predictiveSearchResults.setAttribute("aria-hidden", "true");
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define("predictive-search", PredictiveSearch);
function changeInputPlaceholder() {
  if (!!document.getElementById("Search")) {
    let searchInput = document.getElementById("Search")
    if (screen.width < 1316) {
      if (!!searchInput.getAttribute('data-placeholder-mobile')) {
        if (searchInput.getAttribute('placeholder') !== searchInput.getAttribute('data-placeholder-mobile')) {
          searchInput.setAttribute('placeholder',searchInput.getAttribute('data-placeholder-mobile'))
        }
      }
    }else {
      if (!!searchInput.getAttribute('data-placeholder-desk')) {
        if (searchInput.getAttribute('placeholder') !== searchInput.getAttribute('data-placeholder-desk')) {
          searchInput.setAttribute('placeholder',searchInput.getAttribute('data-placeholder-desk'))
        }
      }
    }

  }
}
document.addEventListener('DOMContentLoaded', e =>{ changeInputPlaceholder()})
window.addEventListener('resize', e =>{ changeInputPlaceholder()})

